import cn from 'classnames'

import { Translation } from 'cng-common/features/translations'
import { getFormattedFinance } from 'cng-common/helpers/numbers'
import { Tooltip } from 'core-components/library/tooltip'
import { MDF_ACTIVITIES_TRANSLATION_KEYS } from 'partner360/features/mdfActivities/configs/translations'
import { formatMdfContraPercent } from 'partner360/features/mdfActivities/lib/formatMdfContraPercent'
import { P360Currency } from 'partner360/models/P360Currency'

import { IKeyInitiativeMdfMetrics } from '../../lib/getKeyInitiativeMdfMetrics'
import { TRANSLATION_KEYS } from '../../translation'

import styles from './KeyInitiativeMdfSection.module.scss'

const KEYS = TRANSLATION_KEYS.keyInitiativeEditor.mdfFieldGroup

export const KeyInitiativeMdfSummary = ({
  plannedUsd,
  paidUsd,
  salesUsd,
  contraPercent,
}: IKeyInitiativeMdfMetrics) => {
  const fields = [
    { key: KEYS.planned, value: plannedUsd },
    { key: KEYS.paid, value: paidUsd },
    { key: KEYS.sales, value: salesUsd },
  ]

  return (
    <dl className={styles.summary}>
      {fields.map(({ key, value }) => (
        <div className={styles.summaryField} key={key}>
          <dt>
            <Translation text={key} span />
          </dt>
          <dd>
            {getFormattedFinance(value, {
              withCurrencySign: true,
              currency: P360Currency.USD,
              maximumFractionDigits: 0,
            })}
          </dd>
        </div>
      ))}
      <div className={styles.summaryField}>
        <dt className={styles.contraLabel}>
          <Translation text={KEYS.contra} span />
          <Tooltip
            inline
            tipContent={() => (
              <Translation
                text={MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.overview.contra.tooltip}
                span
              />
            )}
          >
            <i className={cn('kbase kbase-info', styles.contraInfoIcon)} aria-hidden="true" />
          </Tooltip>
        </dt>
        <dd>{formatMdfContraPercent(contraPercent)}</dd>
      </div>
    </dl>
  )
}
